
/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-08-06
 */

import React, { createContext, ReactNode, useContext, useState } from "react"

interface QueryListContextType {
    ctxData: Map<string, any>;
    getData: (property: string) => any;
    setData: (property: string, value: any) => void;
}

const QueryListContext = createContext<QueryListContextType | undefined>(undefined);

export const QueryListProvider: React.FC<{children: ReactNode}> = (props) => {

    const [ctxData, setCtxData] = useState<Map<string, any>>(new Map());

    const getData = (property: string):any => {
        const result = ctxData.get(property);
        return result;
    }

    const setData = (property: string, value: any):void => {
        setCtxData(prevMap => {
            const newMap = new Map(prevMap);
            newMap.set(property, value);
            return newMap;
        });
    }

    return(
        <QueryListContext.Provider value={{ctxData, getData, setData}}>
            {props.children}
        </QueryListContext.Provider>
    );

}

export const useQueryListContext = () => {
    
    const context = useContext(QueryListContext);
    
    if (!context) {
      throw new Error('useDataListContext must be used within an DataListProvider');
    }

    return context;
  };